import HUSLBlock from "./Block";
import containerQueryPolyfill from "container-query-polyfill";

export class Block extends HUSLBlock {
	constructor(name, node) {
		super(name, node);
	}
	init() {
		console.log(this.name);
	}
}
